module.exports = __webpack_public_path__ + "img/building-01.22d17fd9.svg";